import { Link } from 'react-router-dom';
import { Icon, Logo, socials } from '@byaft/ui';
import { OPEN_CONSENT_EVENT } from '../lib/consent';
import { CYBER_URL, TOOLS_URL } from '../siteConfig';

const year = new Date().getFullYear();

const linkClass = 'text-body-md text-on-background/85 transition-colors hover:text-primary-container';

export function SiteFooter() {
  return (
    <footer className="relative overflow-hidden border-t border-glass-border bg-surface-container-lowest">
      <div className="pointer-events-none absolute -top-32 left-1/2 h-64 w-[60vw] -translate-x-1/2 glow-radial-orange opacity-40 blur-[100px]" />

      <div className="container-byaft relative grid gap-12 py-stack-lg md:grid-cols-[1.4fr_1fr_1fr]">
        <div className="max-w-sm">
          <Logo tone="light" className="text-3xl" />
          <p className="mt-4 text-body-md text-on-surface-variant">
            Fast, free software for everyday digital work — and security for the AI era.
          </p>
        </div>

        <nav aria-label="BYAFT">
          <h2 className="mb-4 font-display text-sm font-bold uppercase tracking-widest text-on-surface-variant">
            BYAFT
          </h2>
          <ul className="space-y-2.5">
            <li>
              <a href={TOOLS_URL} className={linkClass}>
                Tools
              </a>
            </li>
            <li>
              <a href={CYBER_URL} className={linkClass}>
                Cyber
              </a>
            </li>
            <li>
              <Link to="/privacy" className={linkClass}>
                Privacy
              </Link>
            </li>
          </ul>
        </nav>

        <nav aria-label="Follow">
          <h2 className="mb-4 font-display text-sm font-bold uppercase tracking-widest text-on-surface-variant">
            Follow
          </h2>
          <ul className="space-y-2.5">
            {socials.map((s) => (
              <li key={s.label}>
                <a
                  href={s.href}
                  target="_blank"
                  rel="noreferrer noopener"
                  className={`inline-flex items-center gap-2 ${linkClass}`}
                >
                  <Icon name={s.icon} size={16} />
                  {s.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="container-byaft flex flex-col items-center justify-between gap-3 border-t border-glass-border py-6 text-center text-sm text-on-surface-variant md:flex-row md:text-left">
        <p>© {year} BYAFT. Built with energy.</p>
        <div className="flex items-center gap-4">
          <Link to="/privacy" className="transition-colors hover:text-primary-container">
            Privacy Policy
          </Link>
          <button
            type="button"
            onClick={() => window.dispatchEvent(new Event(OPEN_CONSENT_EVENT))}
            className="transition-colors hover:text-primary-container"
          >
            Cookie settings
          </button>
        </div>
      </div>
    </footer>
  );
}
